import { getData } from '../../_helpers/getData';
import React, { useRef } from "react";
import Navbar from "../Navbar";
import TopBar from "../topbar";

import "react-confirm-alert/src/react-confirm-alert.css";
import Footer from "../../layout/footer";
import constant from "../../_config/constant";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SubscriptionPlanManager from "./SubscriptionPlanManager";



export default function SubscriptionPlans() {
  const editorRef = useRef();
  const decoded = getData();

  const handleEditorLog = async () => {
    console.log(editorRef.current.getContent());
  };
  return (
    <div id="main-wrapper">
      <ToastContainer />
      <TopBar user={decoded} showSearch={false} title="Subscription Plans" />

      <div className="deznav">
        <div className="deznav-scroll">
          <Navbar />
        </div>
      </div>

      <div className="content-body">
          <div className="row">
            <SubscriptionPlanManager/>
          </div>
      </div>
      <Footer />
    </div>
  );
}
